import { API_BASE,axiosApi } from "../config"
import {
  GeneralReturnInterface,
  GetPromotionDetailsReturnInterface,
  GetPromotionsReturnInterface,
  PromotionInterface
} from "../types"
axiosApi.defaults.withCredentials = true


export const createPromotion = async (body:{promotion:PromotionInterface}): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/createPromotion`,body)).data
}



export const getPromotions = async (): Promise<GetPromotionsReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getPromotions`)).data
}

export const updatePromotion = async (body:{promotion:PromotionInterface}): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/updatePromotion`,body)).data
}

export const getPromotionDetails = async (body:{code:string}): Promise<GetPromotionDetailsReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getPromotionDetails`,body)).data
}
